<template>
  <button
    class="quick-poll-btn"
    :class="btnClasses"
    @click="$emit('clickBtn')"
  >
    <BaseTransitionAnimations name="fade">
      <span
        v-if="answeredDelay"
        class="quick-poll-btn__percent"
      >
        {{ statistics }}%</span
      >
    </BaseTransitionAnimations>
    <span class="quick-poll-btn__answer"> {{ text }}</span>
  </button>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import BaseTransitionAnimations from '@/components/BaseComponents/BaseTransitionAnimation.vue';

  export default defineNuxtComponent({
    name: 'QuickPollBtn',
    components: { BaseTransitionAnimations },
    props: {
      text: {
        required: true,
        type: String as PropType<string>,
      },

      statistics: {
        required: true,
        type: Number as PropType<number>,
      },

      answeredDelay: {
        required: true,
        type: Boolean as PropType<boolean>,
      },

      isSelected: {
        required: true,
        type: Boolean as PropType<boolean>,
      },

      isAnswered: {
        required: true,
        type: Boolean,
      },
    },

    computed: {
      btnClasses(): Record<string, boolean> | undefined {
        const className = 'quick-poll-btn';
        if (this.isAnswered) {
          return {
            [`${className}--selected`]: Boolean(this.isSelected),
            [`${className}--not-selected`]: !this.isSelected,
          };
        }

        return undefined;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .quick-poll-btn {
    padding: $spacing-3 $spacing-2;
    color: #fff;
    width: calc(50% - 1px);
    background-color: var(--secondary-color);
    font-size: 16px;
    line-height: 42px;
    min-width: 112px;
    @include hover {
      background:
        linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), var(--secondary-color);
    }

    @include tablet {
      font-size: 20px;
    }
    &__percent {
      display: block;
      font-family: $headline-font--1;
      line-height: 42px;
      font-size: 36px;
      @include tablet {
        font-size: 32px;
      }
    }
    &__answer {
      display: block;
      font-family: $text-font--1;
      font-weight: 500;
      @include smallText;
    }
    &--selected,
    &--not-selected {
      .quick-poll-btn__answer {
        line-height: 20px;
        font-size: 14px;
      }
    }
    &--selected {
      background-color: var(--secondary-color);
      color: #fff;
      @include hover {
        background: var(--secondary-color);
      }
    }
    &--not-selected {
      background-color: #fff;
      color: var(--secondary-color);
      .quick-poll-btn__answer {
        color: #777474;
      }
      @include hover {
        background: #fff;
      }
    }
  }
</style>
